// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-l_gZ","advertDetailContactGroup__header":"c-l_ha","advertDetailContactGroup__value":"c-l_hb"};